import { render, staticRenderFns } from "./ListDistributor.vue?vue&type=template&id=1296c9da&"
import script from "./ListDistributor.vue?vue&type=script&setup=true&lang=js&"
export * from "./ListDistributor.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ListDistributor.vue?vue&type=style&index=0&id=1296c9da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports